import { render, staticRenderFns } from "./ascBtn.vue?vue&type=template&id=f061c35c&scoped=true&"
import script from "./ascBtn.vue?vue&type=script&lang=js&"
export * from "./ascBtn.vue?vue&type=script&lang=js&"
import style0 from "./ascBtn.vue?vue&type=style&index=0&id=f061c35c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f061c35c",
  null
  
)

export default component.exports